import moment from 'moment';

export const formatDate = (iso: string) => moment.parseZone(iso).format('DD/MM/YYYY');

export const formatDateTime = (iso: string) => moment.parseZone(iso).format('DD/MM/YYYY HH:mm');

export const formatDateTimeLong = (iso: string) =>
  moment.parseZone(iso).format('DD/MM/YYYY [às] HH:mm');

// Vencido = vencimento antes de hoje (data local); vencer hoje ainda vale.
export const isExpired = (iso: string | null | undefined) =>
  !!iso && moment(iso.slice(0, 10), 'YYYY-MM-DD').isBefore(moment().startOf('day'));
